<template>
  <div v-if="term" class="facet is-single" :class="{ 'is-disabled': !term }">
    <div class="facet-terms">
      <SearchFacetTerm :term="term" :facet-id="facetKey">
        <SpriteSymbol
          v-if="facetKey === 'sustainability'"
          name="sustainability"
          class="icon ml-1 text-success"
        />
      </SearchFacetTerm>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type {
  SearchFacet,
  SearchFacetTerm,
} from '~~/layers/legacy-search/app/types'

const props = withDefaults(
  defineProps<{
    facetKey: SearchFacet['key']
    terms: SearchFacetTerm[]
    label: SearchFacet['label']
    color?: string
  }>(),
  {
    facetKey: '',
    terms: () => [],
    label: '',
    color: '',
  },
)

const { $texts } = useEasyTexts()

const termToUse = computed(() => {
  if (props.facetKey === 'has_virtual_tour') {
    return props.terms.find((v) => v.key === 'true')
  }

  return props.terms[0]
})

const term = computed(() => {
  if (!termToUse.value) {
    return
  }
  if (labelOverride.value) {
    return {
      ...termToUse.value,
      label: labelOverride.value,
    }
  }

  return termToUse.value
})

const labelOverride = computed(() => {
  if (props.facetKey === 'has_virtual_tour') {
    return $texts('virtualTour')
  }

  return null
})
</script>
